import AddTemplateModule from '@/modules/fantasy/contest-template/add-template';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/dashboard/fantasy/contest-template/add-template/'
)({
  component: AddTemplatePage,
});

function AddTemplatePage() {
  return <AddTemplateModule />;
}
